<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    legend: Object,
    buttons: Object,
    widthRight: {
      type: Number,
      default: 60
    },
    xls: String,
  },
  data() {
    return {
      height: 500,
      page: 1,
    }
  },
  methods: {
    spanMethod(v) {

    },
    currentChange(v) {
      this.page = v;
    }
  },
  computed: {
    txt_from() {
      return (this.page - 1) * this.legend.col + 1;
    },
    txt_to() {
      return (this.page * this.legend.col) > this.list.length ? this.list.length : this.page * this.legend.col;
    },
  },
  watch: {},
  components: {},
  mounted() {

  },
  destroyed() {

  },
}
</script>
<template>
  <div class="mag-result" v-if="list&&legend&&legend.columns&&legend.columns.length">
    <div class="mag-result__panel">
      <div class="mag-result__panel-left">
        <el-pagination
          layout="pager"
          :page-size="legend.col"
          @current-change="currentChange"
          :total="list.length">
        </el-pagination>
        <div v-if="list.length>0">{{txt_from}} - {{txt_to}} из {{list.length}}</div>
      </div>
      <div class="mag-result__panel-right">
        <a v-if="xls" :href="xls">
          <el-button type="primary">XLS</el-button>
        </a>
        <el-button type="primary">Расширенный режим</el-button>
        <el-button type="primary" class="search-panel__top-button--icon" icon="mag-icon-nav-menu-setting"
                   title="Настройки"></el-button>
      </div>
    </div>
    <el-table
      :data="list"
      border=""
      :max-height="height"
      style="width: 100%"
      v-if="legend&&legend.columns.length"
      :span-method="spanMethod"
    >
      <el-table-column
        sortable
        v-for="column in legend.columns"
        :key="column.name"
        :prop="column.name"
        :label="column.label"
        :width="column.width"
        :fixed="column.fixed"
      >
        <template slot-scope="scope">
          <template v-if="column.type=='SerializedDate'">
            {{scope.row[column.name] ? scope.row[column.name].Serialized : ''}}
          </template>
          <template v-else>
            {{scope.row[column.name]}}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-if="buttons"
        fixed="right"
        class-name="mag-result__col-right"
        label=""
        :width="buttons.width"
      >
        <template slot-scope="scope">
          <div
            v-for="button in buttons.items"
            :title="button.title"
            class="mag-result__table-button"
            :class="{'is-disabled': button.disabled?button.disabled(scope.row):false}"
            @click="button.click?button.click(scope.row):''"
          >
            <i :class="button.icon"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mag-table__panel">
    </div>
  </div>
</template>
<style lang="scss">
  .mag-result {
    .el-table {
      td.mag-result__col-right {
        .cell {
          padding: 0;
          height: 100%;
          display: flex;
          justify-content: space-between;
          background: #fff;
        }
      }
    }

    &__table-button {
      width: 28px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
      background: #ddd;
      margin: 1px;
      border-radius: 4px;

      &:hover {
        box-shadow: 0 1px 0 0 #999;
      }

      &.is-disabled {
        opacity: 0.75;
        pointer-events: none;
        cursor: not-allowed;
      }
    }

    &__panel {
      display: flex;
      width: 100%;
      height: 40px;
      border: 1px solid #eee;
      line-height: 38px;
      justify-content: space-between;

      &-left {
        display: flex;
      }

      .el-pagination {
        padding: 0 10px 0 0;
        height: 100%;
        margin: 0;

        li {
          padding: 0 4px;
          height: 100%;
          line-height: 38px;
          min-width: 30px;
          font-size: 13px;
          font-weight: 500;
          border-right: 1px solid #ddd;

          &.active {
            background-color: #f2e073;
            border-color: #f2e073;
            color: #333;
          }
        }
      }

      &-right {
        margin-right: 8px;

        & > * {
          margin-left: 8px;
        }
      }
    }
  }
</style>
